import { render, staticRenderFns } from "./cib.vue?vue&type=template&id=4dc3ccf5&scoped=true&"
import script from "./cib.vue?vue&type=script&lang=js&"
export * from "./cib.vue?vue&type=script&lang=js&"
import style0 from "./cib.vue?vue&type=style&index=0&id=4dc3ccf5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3ccf5",
  null
  
)

export default component.exports